export default __webpack_public_path__ + "static/comments-88080b6820fe77479bbc7ea31b7bc3ca.png";